// extracted by mini-css-extract-plugin
export default {"container":"Cards_container__BAfvg"};